/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Start_Attach_HintInputs */

const vi_cdo_start_attach_hint = /** @type {(inputs: Cdo_Start_Attach_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn sẽ được gắn vào chuyến đang chạy của bạn.`)
};

/**

* @param {Cdo_Start_Attach_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_start_attach_hint = /** @type {((inputs?: Cdo_Start_Attach_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Start_Attach_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_start_attach_hint(inputs)
});